const NotFound = () => {
  return (
    <div className="page-wrap" style={{ backgroundColor: "#ff0000" }}>
      <h1>404</h1>
    </div>
  );
};

export default NotFound;
